import React from 'react';
import { Card } from 'react-bootstrap';

const StatCard = ({ icon: Icon, title, count, color, subtext }) => {
  return (
    <Card
      className="border-0 shadow-sm h-100 position-relative overflow-hidden rounded-4"
      style={{
        background: `linear-gradient(145deg, ${color}10, ${color}02)`,
        backdropFilter: "blur(2px)",
        transition: "all 0.3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = "0 6px 20px rgba(0, 0, 0, 0.08)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 2px 10px rgba(0, 0, 0, 0.04)";
      }}
    >
      <Card.Body>
        <div className="d-flex justify-content-between align-items-start">
          <div>
            <h5 className="text-dark fw-semibold" style={{fontWeight: '700'}}>{title}</h5>
            <h5 className="fw-bold text-dark mb-0">{count}</h5>
            {subtext ? (
              <div className="text-muted large mt-1">{subtext}</div>
            ): null}
          </div>
          <div
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{width: "42px",height: "42px",backgroundColor: `${color}22`,color,}}
            >
            <Icon size={20} />
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default StatCard;
